/**
 * The last live data a club TV screen showed, kept in this browser.
 *
 * A TV has to keep its standings up when the server is down, including across
 * a reload, and the service worker's saved copies are not enough for that on
 * their own. A hard refresh skips the service worker, and signage and kiosk
 * browsers often run without one or clear it. Tested on 2026-09-27: with the
 * server stopped, a reload that bypassed the worker left the club screen with
 * nothing to show.
 *
 * So each TV screen also writes its last live payload here and starts from it,
 * marked as not live, until the server answers. Only public board data goes in,
 * the same for every viewer, so it does not need clearing on sign-out.
 *
 * Storage can be missing or refuse writes (private windows, full quota), so
 * every access is guarded and a failure just means starting empty.
 */

const PREFIX = 'tvSnapshot:';

export function readTvSnapshot(key) {
  try {
    const raw = window.localStorage.getItem(PREFIX + key);
    if (!raw) return null;
    const snapshot = JSON.parse(raw);
    return snapshot && snapshot.data && typeof snapshot.savedAt === 'number' ? snapshot : null;
  } catch (error) {
    return null;
  }
}

export function writeTvSnapshot(key, data) {
  try {
    window.localStorage.setItem(PREFIX + key, JSON.stringify({ savedAt: Date.now(), data }));
  } catch (error) {
    // Nothing to do. The screen still works; it just cannot survive a reload offline.
  }
}
